/** Texan contact page layout + form verification v2 */
(function () {
  document.addEventListener('DOMContentLoaded', setupContactPageLayout);

  function setupContactPageLayout() {
    if (!document.body.classList.contains('template-contact')) return;

    const mainContent = document.getElementById('MainContent');
    if (!mainContent) return;

    const formSection = mainContent.querySelector('.shopify-section .texan-contact')?.closest('.shopify-section');
    const legacySections = mainContent.querySelectorAll('.shopify-section');

    legacySections.forEach(function (section) {
      if (section === formSection) return;
      if (section.querySelector('.main-page-title') && !section.querySelector('.texan-contact')) {
        section.remove();
      }
    });

    if (formSection && formSection !== mainContent.firstElementChild) {
      mainContent.prepend(formSection);
    }

    const contactRoot = mainContent.querySelector('.texan-contact');
    if (!contactRoot) return;

    if (!contactRoot.querySelector('.main-page-title')) {
      const title = document.createElement('h1');
      title.className = 'main-page-title page-title h0';
      title.textContent = 'Contact Us';
      contactRoot.prepend(title);
    }

    if (!contactRoot.querySelector('.texan-contact__map')) {
      const mapWrap = document.createElement('div');
      mapWrap.className = 'texan-contact__map-wrap';
      mapWrap.innerHTML =
        '<iframe class="texan-contact__map" src="https://maps.google.com/maps?q=Texas,USA&amp;t=&amp;z=6&amp;ie=UTF8&amp;iwloc=&amp;output=embed" title="Map of Texas" width="100%" height="420" loading="lazy" referrerpolicy="no-referrer-when-downgrade" allowfullscreen></iframe>';
      contactRoot.appendChild(mapWrap);
    }
  }

  const forms = document.querySelectorAll('[data-texan-contact-form]');
  if (!forms.length) return;

  forms.forEach(initForm);

  function initForm(form) {
    if (form.dataset.texanContactInit === 'true') return;
    form.dataset.texanContactInit = 'true';

    const honeypot = form.querySelector('[data-texan-honeypot]');
    const captchaInput = form.querySelector('[data-texan-captcha-input]');
    const captchaQuestion = form.querySelector('[data-texan-captcha-question]');
    const captchaError = form.querySelector('[data-texan-captcha-error]');
    const submitButton = form.querySelector('[type="submit"]');

    if (captchaQuestion && captchaInput) {
      const a = Math.floor(Math.random() * 8) + 2;
      const b = Math.floor(Math.random() * 8) + 2;
      captchaQuestion.textContent = 'What is ' + a + ' + ' + b + '?';
      form.dataset.captchaAnswer = String(a + b);
    }

    form.addEventListener('submit', function (event) {
      if (honeypot && honeypot.value.trim() !== '') {
        event.preventDefault();
        return;
      }

      if (!captchaInput || !form.dataset.captchaAnswer) return;

      const answer = captchaInput.value.trim();
      if (answer !== form.dataset.captchaAnswer) {
        event.preventDefault();
        if (captchaError) {
          captchaError.hidden = false;
        }
        captchaInput.setAttribute('aria-invalid', 'true');
        captchaInput.focus();
        if (submitButton) {
          submitButton.removeAttribute('aria-busy');
        }
      }
    });

    if (captchaInput) {
      captchaInput.addEventListener('input', function () {
        if (captchaError) {
          captchaError.hidden = true;
        }
        captchaInput.removeAttribute('aria-invalid');
      });
    }
  }
})();
